import wishlist from './wishlist'

function buildSlider (products, container, atc = true) {
  if (!container.hasChildNodes()) {
    products.forEach(product => {
      const productDiv = document.createElement("div");
      productDiv.classList.add("grid", "grid-cols-1", "gap-1", "p-2");
      let atcButton =   `<div class="text-center">
          <div data-cart-add="${product.variants[0].id}" class="btn btn--primary mb-1 mx-auto w-full md:w-auto">Add to cart</div>
        </div>`

      productDiv.innerHTML = `<div class="text-center mb-2 md:mb-0 relative">
        <a href="${product.url}"><img src="${product.images[0]}" class="mx-auto" style="width: 200px; max-width: 100%; height: 200px; max-height: 100%; object-fit: contain;" /></a>
        <i
          class="far fa-heart text-enewton-gray-400 cursor-pointer wishlist"
          data-wishlist-toggle
          data-product-id="${product.id}"
          data-product-url="${product.handle}"
        ></i>
      </div>
      <div class="text-center font-display mb-2 md:mb-0">
        <a href="${product.url}" class="no-underline lowercase text-sm">
          ${product.title}
        </a>
      </div>
      <div class="text-center text-center mb-2 md:mb-0">
        $${(product.price / 100).toFixed(2)} USD
      </div>
        ${ atc ? atcButton : ""}`;

        container.appendChild(productDiv);
    });
  }
  $(window).on("load resize orientationchange", function() {
    initSlider()
  });
  initSlider ()
  wishlist()
}

function loadProductRecommendationsIntoSection (productRecommendationsSection, container, data = {}) {
  if (productRecommendationsSection === null) {
    return;
  }
  // Read product id from data attribute
  let productId,
      atc = true;

  if (Object.keys(data).length > 0) {
    productId = data.product_id;
    atc = false;
  } else {
    productId = productRecommendationsSection.dataset.productId;
  }
  // Read base URL from data attribute
  let baseUrl = productRecommendationsSection.dataset.baseUrl;
  // Read limit from data attribute
  let limit = productRecommendationsSection.dataset.limit;
  // Build request URL
  let requestUrl =
    baseUrl +
    "?section_id=product-recommendations&product_id=" +
    productId +
    "&limit=" +
    limit;

  fetch(requestUrl)
   .then(response => response.json())
   .then(({ products }) => {
     if (products.length > 0) {
       buildSlider (products, container, atc)
     }
   });
};

function initSlider () {
  $(".product-recommendations-list").each(function() {
    let $carousel = $(this);
    if ($(window).width() > 768) {
      if ($carousel.hasClass("slick-initialized")) {
        $carousel.slick("unslick");
      }
    } else {
      if (!$carousel.hasClass("slick-initialized")) {
        $carousel.slick({
          slidesToShow: 2,
          slidesToScroll: 1,
          mobileFirst: true,
          arrows: true
        });
      }
    }
  });
}
function initCart (){
  let productRecommendationsSection = document.querySelector(".cart__root .product-recommendations");
  let cartContainer = document.querySelector(".cart__root .product-recommendations-list");
  // Listen for changes done in the Theme Editor
  document.addEventListener("shopify:section:load", function(event) {
    if (event.detail.sectionId === "product-recommendations") {
      loadProductRecommendationsIntoSection(productRecommendationsSection, cartContainer);
    }
  });
  // Fetching the recommendations on page load
  loadProductRecommendationsIntoSection(productRecommendationsSection, cartContainer);
}
function initMiniCart (data){
  let productRecommendationsSection = document.querySelector(".atc-notice .product-recommendations");
  let cartContainer = document.querySelector(".atc-notice .product-recommendations-list");
  // Listen for changes done in the Theme Editor
  document.addEventListener("shopify:section:load", function(event) {
    if (event.detail.sectionId === "product-recommendations") {
      loadProductRecommendationsIntoSection(productRecommendationsSection, cartContainer, data);
    }
  });
  // Fetching the recommendations on page load
  loadProductRecommendationsIntoSection(productRecommendationsSection, cartContainer, data);
}


export { initCart, initMiniCart };
